import React from "react";
import ArrowLeftIcon from "icons/arrow-left-icon.svg";

const BtnReturnBack = (props: any) => {
    const handleClick = () => {
        props.handler();
    };

    return (
        <div className="link d-flex align-items-center gap-1" onClick={handleClick}>
            <ArrowLeftIcon /> Назад
        </div>
    );
};

export default BtnReturnBack;
